import * as toastr from "toastr";
import { ICAMSKey, IAPIResult, FeatureType, TextPack } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';

import * as events from '../Bus/Bus';
import { ContactListConfig, ICAMSContact } from '../Contacts/ContactsModels';
import { ActivityListType, ActivityCreateModel } from "../Activity/Activity";
import { undefined } from "io-ts";
import { ModalPrompts, PredefinedModalEnum } from "../Utility/ModalPrompts";

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Entity_MaintContact {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openMaintContactCreatePanel = (data: ICAMSKey, callback: Function): void => {
        const self = this;
        Utilities.BlockUI();
        $('#placeholder-for-modals2').load(window.G_SITEFOLDERNAME +'/Maint/IssueContactCreateView', { maintCode: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Create modal
            Utilities.GetModal('#maintContactCreateModal', ModalAction.Create);

            $('#maintContactCreate_NewContactBtn').on('click', function () {
                Utilities.GetModal('#maintContactCreateModal', ModalAction.Hide);
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, function (contacts: Array<ICAMSContact>) {
                    Utilities.GetModal('#maintContactCreateModal', ModalAction.Show);
                    $('#maintContactCreateModal [name="Contact"]').val(contacts[0].ContactRef);
                    $('#maintContactCreateModal [name="ContactListName"]').val(contacts[0].ListName);
                    self.loadAffiliationsLUTs(contacts[0].ContactRef, $('#maintContactCreateModal [name="Affiliation"]'));
                }]));
            });

            // Get form validation
            Utilities.InitFormValidation($("#maintContactCreateModal"));

            $('#maintContactCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                submitForm();
            });

            function submitForm() {
                // Validate
                let form: any = $('#maintContactCreateForm');
                if (form.validate({
                    ignore: '[readonly]',
                    rules: {
                        ContactListName: {
                            required: true
                        }
                    }
                }).form() == false) {
                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_PleaseEnterAllValues" }]).then(m => {
                        if (m.success == true) toastr.error(m.data[0].value);
                        else toastr.error("Please make sure you have entered all required values.");
                    });
                    return;
                }

                Utilities.BlockUI($("#maintContactCreateModal .modal-content"));
                let formData = new FormData(<any>$('#maintContactCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Maint/AddIssueContact',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Contact added!');
                                Utilities.GetModal('#maintContactCreateModal', ModalAction.Hide);
                                callback(result.data);
                            }
                            else {
                                toastr.error('Failed to add contact!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#maintContactCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            }

            $('#maintContactCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#maintContactCreateModal', ModalAction.Hide);
                callback();
            });

            $('#maintContactCreateCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#maintContactCreateModal', ModalAction.Hide);
                callback();
            });
        });
      
    }

    public openMaintContactEditPanel = (ID: number, callback: Function): void => {
        const self = this;
        var maintContactID = ID;

        Utilities.BlockUI();
        $('#placeholder-for-modals2').load(window.G_SITEFOLDERNAME +'/Maint/IssueContactEditView', { ID: ID }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            // Edit modal
            Utilities.GetModal('#maintContactEditModal', ModalAction.Create);

            $('#maintContactEdit_ContactListName').on('click', function () {
                Utilities.GetModal('#maintContactEditModal', ModalAction.Hide);
                var contactRef = $('#maintContactEditModal [name="Contact"]').val() as string;

                events.bus.publish(events.eventOpenContactsEditPanel([{ code: contactRef, featureType: FeatureType.Contact }, false, function (listName) {
                    if (listName != null) $('#maintContactEdit_ContactListName').val(listName);
                    Utilities.GetModal('#maintContactEditModal', ModalAction.Show);
                }]));
            });

            $('#maintContactEdit_NewContactBtn').on('click', function () {
                Utilities.GetModal('#maintContactEditModal', ModalAction.Hide);
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, function (contacts: Array<ICAMSContact>) {
                    Utilities.GetModal('#maintContactEditModal', ModalAction.Show);
                    $('#maintContactEditModal [name="Contact"]').val(contacts[0].ContactRef);
                    $('#maintContactEditModal [name="ContactListName"]').val(contacts[0].ListName);
                    self.loadAffiliationsLUTs(contacts[0].ContactRef, $('#maintContactEditModal [name="Affiliation"]'));
                }]));
            });

            // Get form validation
            Utilities.InitFormValidation($("#maintContactEditModal"));

            // Create table
            ($('#maintContactEditActivityTable') as any).bootstrapTable();

            // Add Acitvity buttons
            $('#maintContactEditNewActivityBtn').on('click', function () {
                var maintCode = $('#maintContactEditForm [name="MaintCode"]').val().toString();
                var assignTo = $('#maintContactEditForm [name="Contact"]').val();
                var affiliation = $('#maintContactEditForm [name="Affiliation"]').val();

                if (assignTo == null || affiliation == null) {
                    toastr.error("You must fill in the Contact and Affiliation fields first.");
                    return;
                }

                Utilities.GetModal('#maintContactEditModal', ModalAction.Hide);
                var query: ActivityCreateModel = { ID: maintCode, activityListType: ActivityListType.MaintActivity, contactRef: assignTo.toString(), affiliation: affiliation.toString() };
                events.bus.publish(events.eventOpenActivityCreatePanel([query, function (result) {
                    self.openMaintContactEditPanel(maintContactID, callback);
                }]));
            });

            //$('#maintContactEditActivityTable [data-maintcontactid]').on('click', function () {
            var table: any = Utilities.GetControl('#maintContactEditActivityTable');
            table.bootstrapTable();
            table.on('click-cell.bs.table', function (e, field, value, row, $element) { 
                if (field == "activityDate") {
                    const ID: number = $element.data("maintcontactid");
                    Utilities.GetModal('#maintContactEditModal', ModalAction.Hide);
                    events.bus.publish(events.eventOpenActivityDetailsPanel([ID, function (result) {
                        self.openMaintContactEditPanel(maintContactID, callback);
                    }]));
                }
            });

            // Submit
            $('#maintContactEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();
                // Validate
                let form: any = $('#maintContactEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#maintContactEditModal .modal-content"));
                let formData = new FormData(<any>$('#maintContactEditForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Maint/UpdateIssueContact',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Contact update!');
                                Utilities.GetModal('#maintContactEditModal', ModalAction.Hide);
                                callback();
                            }
                            else {
                                toastr.error('Failed to update contact!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($("#maintContactEditModal"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#maintContactEditDeleteBtn').on('click', function (evt) {
                self.deleteContact(maintContactID, callback);
            });

            $('#maintContactEditCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#maintContactEditModal', ModalAction.Hide);
                callback();
            });

            $('#maintContactEditCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#maintContactEditModal', ModalAction.Hide);
                callback();
            });
        });

    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteContact = (ID: number, callback: Function): void => {
        const self = this;

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Maint/DeleteIssueContact', {ID: ID},
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            Utilities.GetModal('#maintContactEditModal', ModalAction.Hide);
                            callback();
                        }
                        else {
                            if (result.message != null) toastr.error(result.message);
                            else toastr.error('Failed to delete feature!');
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // MISC
    private loadAffiliationsLUTs = (contactRef: string, el: JQuery<HTMLElement>): void => {
        const self = this;
        $.post('/Contact/GetAffiliationsForContact', { contactRef: contactRef },
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        el.find('option').remove().end();
                        result.data.forEach(i => {
                            el.append($("<option></option>").attr("value", i.value).text(i.text));
                        });
                    }
                    else {
                        if (result.message != null) toastr.error(result.message);
                        else toastr.error('Failed to get affiliations!');
                    }
                }
                catch (err) {
                    console.log(err);
                    toastr.error('Error getting affiliations!');
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }
}




